import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IAnswerTaskModel } from 'models/answerTask.model'

export const ANSWER_TASK_CREATE = 'ANSWER_TASK_CREATE'
export const ANSWER_TASK_CREATE_SUCCESS = 'ANSWER_TASK_CREATE_SUCCESS'
export const ANSWER_TASK_EDIT = 'ANSWER_TASK_EDIT'
export const ANSWER_TASK_EDIT_SUCCESS = 'ANSWER_TASK_EDIT_SUCCESS'
export const ANSWER_TASK_DELETE = 'ANSWER_TASK_DELETE'
export const ANSWER_TASK_DELETE_SUCCESS = 'ANSWER_TASK_DELETE_SUCCESS'

export const Actions = {
  answerTaskCreateSuccess: (ids: []) => createAction(ANSWER_TASK_CREATE_SUCCESS, ids),
  answerTaskEditSuccess: (data: IAnswerTaskModel) => createAction(ANSWER_TASK_EDIT_SUCCESS, data),
  answerTaskDeleteSuccess: () => createAction(ANSWER_TASK_DELETE_SUCCESS),
}

export type Actions = ActionsUnion<typeof Actions>
